import { Link } from "react-router-dom";
import { articleList } from "@/mocks/articles";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-10 md:py-14">
        <div className="flex flex-col lg:flex-row items-start justify-between gap-8">
          <div className="flex flex-col gap-2 max-w-xs">
            <Link
              to="/"
              className="font-heading text-xl font-bold tracking-tight text-foreground-900"
            >
              Sugargoo<span className="text-primary-500">Sheet</span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              Your ultimate resource for Sugargoo Spreadsheet discoveries, shopping guides, and product recommendations. Updated 2026.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6">
            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">Quick Links</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Home</Link>
                <Link to="/sugargoo-spreadsheet-guide" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Shopping Guide</Link>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-500 hover:text-primary-600 transition-colors whitespace-nowrap">Main Store</a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">Top Guides</h4>
              <div className="flex flex-col gap-2">
                {articleList.slice(0, 5).map((a) => (
                  <Link key={a.slug} to={`/${a.slug}`} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors truncate max-w-[180px] whitespace-nowrap">{a.title.length > 30 ? a.title.slice(0, 30) + "..." : a.title}</Link>
                ))}
              </div>
            </div>

            <div>
              <h4 className="text-xs font-semibold text-foreground-400 uppercase tracking-wider mb-3">More Resources</h4>
              <div className="flex flex-col gap-2">
                {articleList.slice(5).map((a) => (
                  <Link key={a.slug} to={`/${a.slug}`} className="text-sm text-foreground-500 hover:text-primary-600 transition-colors truncate max-w-[180px] whitespace-nowrap">{a.title.length > 30 ? a.title.slice(0, 30) + "..." : a.title}</Link>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 pt-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} SugargooSheet.fit — All rights reserved. Independent resource website.
          </p>
          <div className="flex items-center gap-4">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap">Privacy</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap">Terms</a>
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-400 hover:text-primary-600 transition-colors whitespace-nowrap">Disclaimer</a>
          </div>
        </div>
      </div>
    </footer>
  );
}